import { createApi } from './callApi';
const contentApi = createApi('CONTENT');

export const uploadImage = (name, image) => {
    const body = new FormData();
    body.append('file', image);
    return contentApi({ method: 'POST', target: name, body });
};
